import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2025EvidenciasFotograficas() {
  return <CategoryPage category="anexo30Y31Ano2025EvidenciasFotograficas" pageTitle="Evidencias Fotograficas 2025" />;
}

export default Anexo30Y31Ano2025EvidenciasFotograficas;
